module.exports = __webpack_public_path__ + "img/30_54.880c4dd0.png";